'use strict';

var angular = require('angular');
var dependencies = ['AVRO.ScheduleChange.WizardStep'];
module.exports = angular.module('AVRO.ScheduleChange.LegWizard', dependencies).controller('LegWizardController', require('./controllers/LegWizardController')).directive('rmLegWizard', require('./directives/LegWizardDirective'));